import { takeLatest, put, call } from "redux-saga/effects";
import {
  ADMIN_GROUP_GET_ALL_DATA, ADMIN_GROUP_GET_ALL_API,
  ADMIN_GROUP_GET_BY_ID_DATA, ADMIN_GROUP_GET_BY_ID_API,
  ADMIN_GROUP_ADD_DATA, ADMIN_GROUP_POST_API,
  ADMIN_GROUP_UPDATE_DATA, ADMIN_GROUP_PUT_API,
  ADMIN_GROUP_DELETE_DATA, ADMIN_GROUP_DELETE_API,
  ADMIN_GROUP_GET_DATA, ADMIN_GROUP_GET_DETAIL_API,
  ADMIN_GROUP_UPDATE_FLAG_DATA, ADMIN_GROUP_UPDATE_FLAG_API,
} from "./Constants";
import {
  setAdminGroupGetAllSuccess, setAdminGroupGetAllFail,
  setAdminGroupGetByIdSuccess,setAdminGroupGetByIdFail,
  setAdminGroupAddDataSuccess, setAdminGroupAddDataFail,
  setAdminGroupUpdateDataSuccess, setAdminGroupUpdateDataFail,
  setAdminGroupDeleteDataSuccess, setAdminGroupDeleteDataFail,
  setAdminGroupGetDataSuccess, setAdminGroupGetDataFail,
  setAdminGroupUpdateFlagSuccess, setAdminGroupUpdateFlagFail,
} from "./Actions";
import { addErrorAlert, addSuccessAlert } from "../../../alert/Actions";
import { ticketApi } from "../../../../shared/components/Service";


// Get All
function* getAllAdminGroupService({ request }) {
  try {
    const response = yield call(ticketApi.get , ADMIN_GROUP_GET_ALL_API, request);
    const status = response?.status;
    const apiData = response?.data || response;
    if (status === 200 || apiData?.success) {
      yield put(setAdminGroupGetAllSuccess(apiData.data));
    } else {
      yield put(addErrorAlert(apiData.msg || "Error fetching Job Titles"));
      yield put(setAdminGroupGetAllFail(apiData.msg));
    }
  } catch (error) {
    const msg = error?.response?.data?.msg || error?.message || "Error fetching Job Titles";
    yield put(addErrorAlert(msg));
    yield put(setAdminGroupGetAllFail(msg));
  }
}

// Get By ID
function* getByIdAdminGroupService({ id }) {
  try {
    const response = yield call(ticketApi.get, ADMIN_GROUP_GET_BY_ID_API + id);
    const status = response?.status;
    const apiData = response?.data || response;
    if (status === 200 || apiData?.success) {
      yield put(setAdminGroupGetByIdSuccess(apiData.data));
    } else {
      yield put(addErrorAlert(apiData.msg || "Error fetching Job Title"));
      yield put(setAdminGroupGetByIdFail(apiData.msg));
    }
  } catch (error) {
    const msg = error?.response?.data?.msg || error?.message || "Error fetching Job Title";
    yield put(addErrorAlert(msg));
    yield put(setAdminGroupGetByIdFail(msg));
  }
}

// Add Job Title
function* addAdminGroupService({ id, request }) {
  try {
    const response = yield call(ticketApi.post, ADMIN_GROUP_POST_API , request);
    const status = response?.status;
    const apiData = response?.data || response;
    if (status === 200 || status === 201 || apiData?.success) {
      yield put(addSuccessAlert(apiData.msg || "Job Title added"));
      yield put(setAdminGroupAddDataSuccess(apiData.data));
    } else {
      yield put(addErrorAlert(apiData.msg || "Error adding Job Title"));
      yield put(setAdminGroupAddDataFail(apiData.msg));
    }
  } catch (error) {
    const msg = error?.response?.data?.msg || error?.message || "Error adding Job Title";
    yield put(addErrorAlert(msg));
    yield put(setAdminGroupAddDataFail(msg));
  }
}

// Update Job Title
function* updateAdminGroupService({ request }) {
  try {
    const response = yield call(ticketApi.put, ADMIN_GROUP_PUT_API + request.id, request);
    if (response.status === 200) {
     // yield put(addSuccessAlert("Job Title updated"));
      yield put(setAdminGroupUpdateDataSuccess(response.data.data));
    } else {
      yield put(addErrorAlert(response.response.data.msg));
      yield put(setAdminGroupUpdateDataFail(response.response.data));
    }
  } catch (error) {
    //yield put(addErrorAlert("Could not update Job Title"));
    yield put(setAdminGroupUpdateDataFail(error));
  }
}

// Delete Job Title
function* deleteAdminGroupService({ payload }) {
  try {
    const { group_id, job_title_ids } = payload;

    const response = yield call(
      ticketApi.delete,
      ADMIN_GROUP_DELETE_API + payload.id, payload

    );

    if (response.status === 200) {
      yield put(addSuccessAlert("Job Title deleted"));
      yield put(setAdminGroupDeleteDataSuccess(response.data.data));
    } else {
      yield put(addErrorAlert(response.response.data.msg));
      yield put(setAdminGroupDeleteDataFail(response.response.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Error deleting Job Title"));
    yield put(setAdminGroupDeleteDataFail(error));
  }
}
// get ALL AdminGroup
function* getAdminGroupDataService() {
  try {
    const response = yield call(
      ticketApi.get,
      ADMIN_GROUP_GET_DETAIL_API
    );
    const status = response.status;
    if (status === 200) {
      const data = response.data;
      yield put(setAdminGroupGetDataSuccess(data));
    } else {
      yield put(setAdminGroupGetDataFail(response.response.data));
    }
  } catch (error) {
    yield put(setAdminGroupGetDataFail(error));
  }
}

// Update Admin Flag
function* updateAdminGroupFlagService({ request }) {
  try {
    const { group_id, ...flags } = request;
    const url = `${ADMIN_GROUP_UPDATE_FLAG_API}${group_id}/flags`;
    const response = yield call(ticketApi.patch, url, flags);
    const status = response?.status;
    const apiData = response?.data || response;
    if (status === 200 || apiData?.success) {
      yield put(addSuccessAlert(apiData.message || "Flags updated successfully"));
      yield put(setAdminGroupUpdateFlagSuccess(apiData));
    } else {
      yield put(addErrorAlert(apiData.message || "Error updating admin flags"));
      yield put(setAdminGroupUpdateFlagFail(apiData.message));
    }
  } catch (error) {
    const msg = error?.response?.data?.message || error?.message || "Error updating admin flags";
    yield put(addErrorAlert(msg));
    yield put(setAdminGroupUpdateFlagFail(msg));
  }
}

export function* watchAdminGroup() {
  yield takeLatest(ADMIN_GROUP_GET_ALL_DATA.ADMIN_GROUP_GET_ALL_LOAD, getAllAdminGroupService);
  yield takeLatest(ADMIN_GROUP_GET_BY_ID_DATA.ADMIN_GROUP_GET_BY_ID_LOAD, getByIdAdminGroupService);
  yield takeLatest(ADMIN_GROUP_ADD_DATA.ADMIN_GROUP_ADD_DATA_LOAD, addAdminGroupService);
  yield takeLatest(ADMIN_GROUP_UPDATE_DATA.ADMIN_GROUP_UPDATE_DATA_LOAD, updateAdminGroupService);
  yield takeLatest(ADMIN_GROUP_DELETE_DATA.ADMIN_GROUP_DELETE_LOAD, deleteAdminGroupService);
  yield takeLatest(ADMIN_GROUP_GET_DATA.ADMIN_GROUP_GET_DATA_LOAD, getAdminGroupDataService);
  yield takeLatest(ADMIN_GROUP_UPDATE_FLAG_DATA.ADMIN_GROUP_UPDATE_FLAG_LOAD, updateAdminGroupFlagService);
}